import AvatarImg from "../../assets/images/avatar.png";
import { ReactComponent as LogoEvino } from "../../assets/images/logo_evino.svg";

import "./style.css";

const Header = () => {
  return (
    <div className="flex pt-6 pb-3 px-10 border-b border-coolGray-350 bg-white">
      <div className="mr-4">
        <img src={AvatarImg} alt="Bot Avatar" />
      </div>

      <div>
        <div className="flex justify-between">
          <h1 className="text-lg font-semibold font-brand text-black">Pipa</h1>

          <LogoEvino
            alt="Logo da Evino"
            className="-mr-4 app-header-evino-logo"
            fill="#E4303E"
          />
        </div>

        <h3 className="text-sm text-gray-400 mt-2">
          Sua assistente no mundo do vinho
        </h3>
      </div>
    </div>
  );
};

export default Header;
